import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      '404 Error: User attempted to access non-existent route:',
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className='min-h-screen flex items-center justify-center bg-gray-50 px-4'>
      <div className='text-center max-w-lg animate-fade-in'>
        <h1 className='text-9xl font-display font-bold text-primary mb-4'>
          404
        </h1>
        <p className='text-2xl font-medium text-gray-800 mb-6'>
          Oops! Page not found
        </p>
        <p className='text-gray-600 mb-8'>
          The page you are looking for might have been removed, had its name
          changed, or is temporarily unavailable.
        </p>
        <Link
          to='/'
          className='inline-flex items-center text-white bg-primary px-6 py-3 rounded-md font-medium hover:bg-primary/90 transition-colors duration-300'
        >
          <ArrowLeft className='w-4 h-4 mr-2' />
          Return to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
